import React from "react";
import { Box, alpha } from "@mui/material";
import { COLORS } from "../../styles/uiConstants";
import { useClinicTheme } from "../../theme";
import PageTitle from "../molecules/PageTitle";
import StatCardsRow from "../molecules/StatCardsRow";

/**
 * Modern sayfa üst kartı (organism): glassmorphism + palette accent.
 * @param {React.ReactNode} icon - PageTitle ikonu
 * @param {string} title - Başlık
 * @param {string} [subtitle] - Alt başlık
 * @param {React.ReactNode} [rightAction] - Sağ üstte buton
 * @param {React.ReactNode} [children] - Filtre/arama satırı
 * @param {Array<{ label, value, variant? }>} [statCards]
 * @param {number} [iconSize] - İkon kutusu boyutu
 */
export default function PageHeaderCard({
  icon,
  title,
  subtitle,
  rightAction,
  children,
  statCards,
  iconSize = 56,
}) {
  const { palette } = useClinicTheme();
  return (
    <Box
      sx={{
        position: "relative",
        borderRadius: 4,
        overflow: "hidden",
        background: COLORS.white,
        boxShadow: "0 8px 28px rgba(15, 23, 42, 0.06), 0 1px 3px rgba(15, 23, 42, 0.04)",
        border: `1px solid ${alpha(palette.primary, 0.08)}`,
        // subtle gradient bg
        backgroundImage: `linear-gradient(135deg, ${alpha(palette.primary, 0.04)} 0%, ${COLORS.white} 35%, ${COLORS.white} 100%)`,
        // top accent strip
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: 3,
          background: `linear-gradient(90deg, ${palette.primary} 0%, ${alpha(palette.primary, 0.6)} 50%, ${alpha(palette.primary, 0.2)} 100%)`,
        },
        // decorative blob
        "&::after": {
          content: '""',
          position: "absolute",
          top: -60,
          right: -60,
          width: 220,
          height: 220,
          borderRadius: "50%",
          background: `radial-gradient(circle, ${alpha(palette.primary, 0.06)} 0%, transparent 70%)`,
          pointerEvents: "none",
        },
      }}
    >
      <Box sx={{ position: "relative", zIndex: 1, p: { xs: 2.5, md: 3 } }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", md: "center" },
            gap: 2,
            flexWrap: "wrap",
          }}
        >
          <PageTitle icon={icon} title={title} subtitle={subtitle} iconSize={iconSize} />
          {rightAction ? <Box sx={{ flexShrink: 0 }}>{rightAction}</Box> : null}
        </Box>

        {(children || (statCards && statCards.length > 0)) ? (
          <Box
            sx={{
              mt: 2.5,
              display: "flex",
              gap: 2,
              flexWrap: "wrap",
              alignItems: "center",
            }}
          >
            {children ? (
              <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap", flex: 1, alignItems: "center" }}>
                {children}
              </Box>
            ) : null}
            {statCards && statCards.length > 0 ? (
              <StatCardsRow items={statCards} alignEnd={!!children} />
            ) : null}
          </Box>
        ) : null}
      </Box>
    </Box>
  );
}
